var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPortfolioBgLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 828,
    height: 3233,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 2592.39C102.68 2592.39 185.109 2674.7 185.109 2776.23C185.109 2877.77 102.68 2960.35 1 2960.35",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 2585.08C94.5459 2585.08 170.467 2667.39 170.467 2768.92C170.467 2870.46 94.5459 2952.77 1 2952.77",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 2577.77C86.4115 2577.77 155.825 2660.08 155.825 2761.61C155.825 2863.14 86.4115 2945.73 1 2945.73",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 2570.46C78.2771 2570.46 140.912 2652.77 140.912 2754.3C140.912 2855.83 78.277 2938.14 1 2938.14",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 2562.87C70.1427 2562.87 126.27 2645.18 126.27 2746.72C126.27 2848.25 70.1426 2930.83 1 2930.83",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 2555.56C62.0082 2555.56 111.628 2637.87 111.628 2739.41C111.628 2840.94 62.0082 2923.52 1 2923.52",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 2548.25C53.8738 2548.25 96.7151 2630.56 96.7151 2732.1C96.7151 2833.63 53.8738 2916.21 1 2916.21",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 2540.94C45.7394 2540.94 82.0731 2623.25 82.0731 2724.79C82.0731 2826.32 45.7393 2908.9 1 2908.9",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 2533.63C37.6049 2533.63 67.4312 2615.94 67.4312 2717.48C67.4311 2819.01 37.6049 2901.32 1 2901.32",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 2526.32C29.4705 2526.32 52.5181 2608.63 52.518 2710.17C52.518 2811.7 29.4705 2894.01 1 2894.01",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 2518.74C21.3361 2518.74 37.8761 2601.05 37.8761 2702.59C37.8761 2804.12 21.3361 2886.7 1 2886.7",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 2511.43C13.2017 2511.43 23.2341 2593.74 23.2341 2695.27C23.2341 2796.81 13.2016 2879.39 1 2879.39",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2776.5C102.68 2776.5 185.109 2694.19 185.109 2592.66C185.109 2491.12 102.68 2408.54 1.00003 2408.54",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2783.81C94.5459 2783.81 170.467 2701.5 170.467 2599.97C170.467 2498.43 94.5459 2416.12 1.00003 2416.12",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2791.12C86.4115 2791.12 155.825 2708.81 155.825 2607.28C155.825 2505.74 86.4115 2423.16 1.00003 2423.16",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2798.43C78.277 2798.43 140.912 2716.12 140.912 2614.59C140.912 2513.05 78.2771 2430.47 1.00003 2430.47",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2805.74C70.1426 2805.74 126.27 2723.43 126.27 2621.9C126.27 2520.36 70.1427 2437.78 1.00003 2437.78",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2813.05C62.0082 2813.05 111.628 2730.74 111.628 2629.21C111.628 2527.68 62.0082 2445.36 1.00003 2445.36",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2820.64C53.8738 2820.64 96.7151 2738.33 96.7151 2636.79C96.7151 2535.26 53.8738 2452.68 1.00003 2452.68",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2827.95C45.7393 2827.95 82.0731 2745.64 82.0731 2644.1C82.0731 2542.57 45.7394 2459.99 1.00003 2459.99",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2835.26C37.6049 2835.26 67.4311 2752.95 67.4312 2651.41C67.4312 2549.88 37.6049 2467.57 1.00003 2467.57",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2842.57C29.4705 2842.57 52.518 2760.26 52.518 2658.72C52.5181 2557.19 29.4705 2474.88 1.00003 2474.88",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2849.88C21.3361 2849.88 37.8761 2767.57 37.8761 2666.03C37.8761 2564.5 21.3361 2481.92 1.00003 2481.92",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2857.19C13.2016 2857.19 23.2341 2774.88 23.2341 2673.34C23.2341 2571.81 13.2017 2489.5 1.00003 2489.5",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2864.77C5.06721 2864.77 8.32099 2782.46 8.321 2680.92C8.32101 2579.39 5.06724 2496.81 1.00003 2496.81",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 2504.12C5.06724 2504.12 8.32101 2586.43 8.321 2687.96C8.32099 2758.09 6.6941 2819.01 4.52492 2850.15",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 3144.19C102.68 3144.19 185.109 3061.88 185.109 2960.35C185.109 2858.81 102.68 2776.5 1.00003 2776.5",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 3151.77C94.5459 3151.77 170.467 3069.19 170.467 2967.66C170.467 2866.12 94.5459 2783.81 1.00003 2783.81",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 3159.08C86.4115 3159.08 155.825 3076.77 155.825 2975.24C155.825 2873.7 86.4115 2791.12 1.00003 2791.12",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 3166.39C78.277 3166.39 140.912 3084.08 140.912 2982.55C140.912 2881.01 78.2771 2798.43 1.00003 2798.43",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 3173.7C70.1426 3173.7 126.27 3091.39 126.27 2989.86C126.27 2888.33 70.1427 2805.74 1.00003 2805.74",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 3181.01C62.0082 3181.01 111.628 3098.7 111.628 2997.17C111.628 2895.64 62.0082 2813.05 1.00003 2813.05",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 3188.33C53.8738 3188.33 96.7151 3106.01 96.7151 3004.48C96.7151 2902.95 53.8738 2820.64 1.00003 2820.64",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 3195.91C45.7393 3195.91 82.0731 3113.6 82.0731 3012.06C82.0731 2910.53 45.7394 2827.95 1.00003 2827.95",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 3203.22C37.6049 3203.22 67.4311 3120.91 67.4312 3019.1C67.4312 2917.3 37.6049 2835.26 1.00003 2835.26",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 3210.53C29.4705 3210.53 52.518 3128.22 52.518 3026.68C52.5181 2925.15 29.4705 2842.84 1.00003 2842.84",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 3217.84C21.3361 3217.84 37.8761 3135.53 37.8761 3033.99C37.8761 2932.46 21.3361 2849.88 1.00003 2849.88",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 3225.15C13.2016 3225.15 23.2341 3142.84 23.2341 3041.3C23.2341 2939.77 13.2017 2857.19 1.00003 2857.19",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 3232.46C5.06721 3232.46 8.32099 3150.15 8.321 3048.61C8.32101 2947.08 5.06724 2864.77 1.00003 2864.77",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 2872.08C5.06724 2872.08 8.32101 2954.39 8.321 3055.92C8.32099 3126.05 6.6941 3186.97 4.52492 3218.11",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 2320.61C102.68 2320.61 185.109 2238.3 185.109 2136.77C185.109 2035.23 102.68 1952.65 1 1952.65",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 2327.92C94.5459 2327.92 170.467 2245.61 170.467 2144.08C170.467 2042.55 94.5459 1960.23 1 1960.23",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 2335.23C86.4115 2335.23 155.825 2252.92 155.825 2151.39C155.825 2049.86 86.4115 1967.27 1 1967.27",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 2342.55C78.2771 2342.55 140.912 2260.23 140.912 2158.7C140.912 2057.17 78.277 1974.86 1 1974.86",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 2350.13C70.1427 2350.13 126.27 2267.82 126.27 2166.28C126.27 2064.75 70.1426 1982.17 1 1982.17",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 2357.44C62.0082 2357.44 111.628 2275.13 111.628 2173.59C111.628 2072.06 62.0082 1989.48 1 1989.48",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 2364.75C53.8738 2364.75 96.7151 2282.44 96.7151 2180.9C96.7151 2079.37 53.8738 1996.79 1 1996.79",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 2372.06C45.7394 2372.06 82.0731 2289.75 82.0731 2188.21C82.0731 2086.68 45.7393 2004.1 1 2004.1",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 2379.37C37.6049 2379.37 67.4312 2297.06 67.4312 2195.52C67.4311 2093.99 37.6049 2011.68 1 2011.68",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 2386.68C29.4705 2386.68 52.5181 2304.37 52.518 2202.83C52.518 2101.3 29.4705 2018.99 1 2018.99",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 2394.26C21.3361 2394.26 37.8761 2311.95 37.8761 2210.42C37.8761 2108.88 21.3361 2026.3 1 2026.3",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 2401.57C13.2017 2401.57 23.2341 2319.26 23.2341 2217.73C23.2341 2116.19 13.2016 2033.61 1 2033.61",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2136.5C102.68 2136.5 185.109 2218.81 185.109 2320.34C185.109 2421.88 102.68 2504.46 1.00003 2504.46",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2129.19C94.5459 2129.19 170.467 2211.5 170.467 2313.03C170.467 2414.57 94.5459 2496.88 1.00003 2496.88",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2121.88C86.4115 2121.88 155.825 2204.19 155.825 2305.72C155.825 2407.26 86.4115 2489.84 1.00003 2489.84",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2114.57C78.277 2114.57 140.912 2196.88 140.912 2298.41C140.912 2399.95 78.2771 2482.53 1.00003 2482.53",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2107.26C70.1426 2107.26 126.27 2189.57 126.27 2291.1C126.27 2392.64 70.1427 2475.22 1.00003 2475.22",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2099.95C62.0082 2099.95 111.628 2182.26 111.628 2283.79C111.628 2385.33 62.0082 2467.64 1.00003 2467.64",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2092.36C53.8738 2092.36 96.7151 2174.68 96.7151 2276.21C96.7151 2377.74 53.8738 2460.33 1.00003 2460.33",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2085.05C45.7393 2085.05 82.0731 2167.37 82.0731 2268.9C82.0731 2370.43 45.7394 2453.01 1.00003 2453.01",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2077.74C37.6049 2077.74 67.4311 2160.05 67.4312 2261.59C67.4312 2363.12 37.6049 2445.43 1.00003 2445.43",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2070.43C29.4705 2070.43 52.518 2152.74 52.518 2254.28C52.5181 2355.81 29.4705 2438.12 1.00003 2438.12",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2063.12C21.3361 2063.12 37.8761 2145.43 37.8761 2246.97C37.8761 2348.5 21.3361 2431.08 1.00003 2431.08",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2055.81C13.2016 2055.81 23.2341 2138.12 23.2341 2239.66C23.2341 2341.19 13.2017 2423.5 1.00003 2423.5",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2048.23C5.06721 2048.23 8.32099 2130.54 8.321 2232.08C8.32101 2333.61 5.06724 2416.19 1.00003 2416.19",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 2408.88C5.06724 2408.88 8.32101 2326.57 8.321 2225.04C8.32099 2154.91 6.6941 2093.99 4.52492 2062.85",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1768.81C102.68 1768.81 185.109 1851.12 185.109 1952.65C185.109 2054.19 102.68 2136.5 1.00003 2136.5",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1761.23C94.5459 1761.23 170.467 1843.81 170.467 1945.34C170.467 2046.88 94.5459 2129.19 1.00003 2129.19",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1753.92C86.4115 1753.92 155.825 1836.23 155.825 1937.76C155.825 2039.3 86.4115 2121.88 1.00003 2121.88",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1746.61C78.277 1746.61 140.912 1828.92 140.912 1930.45C140.912 2031.99 78.2771 2114.57 1.00003 2114.57",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1739.3C70.1426 1739.3 126.27 1821.61 126.27 1923.14C126.27 2024.68 70.1427 2107.26 1.00003 2107.26",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1731.99C62.0082 1731.99 111.628 1814.3 111.628 1915.83C111.628 2017.36 62.0082 2099.95 1.00003 2099.95",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1724.68C53.8738 1724.68 96.7151 1806.99 96.7151 1908.52C96.7151 2010.05 53.8738 2092.36 1.00003 2092.36",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1717.09C45.7393 1717.09 82.0731 1799.4 82.0731 1900.94C82.0731 2002.47 45.7394 2085.05 1.00003 2085.05",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1709.78C37.6049 1709.78 67.4311 1792.09 67.4312 1893.9C67.4312 1995.7 37.6049 2077.74 1.00003 2077.74",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1702.47C29.4705 1702.47 52.518 1784.78 52.518 1886.32C52.5181 1987.85 29.4705 2070.16 1.00003 2070.16",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1695.16C21.3361 1695.16 37.8761 1777.47 37.8761 1879.01C37.8761 1980.54 21.3361 2063.12 1.00003 2063.12",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1687.85C13.2016 1687.85 23.2341 1770.16 23.2341 1871.7C23.2341 1973.23 13.2017 2055.81 1.00003 2055.81",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1680.54C5.06721 1680.54 8.32099 1762.85 8.321 1864.39C8.32101 1965.92 5.06724 2048.23 1.00003 2048.23",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 2040.92C5.06724 2040.92 8.32101 1958.61 8.321 1857.08C8.32099 1786.95 6.6941 1726.03 4.52492 1694.89",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 1408.39C102.68 1408.39 185.109 1490.7 185.109 1592.23C185.109 1693.77 102.68 1776.35 1 1776.35",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 1401.08C94.5459 1401.08 170.467 1483.39 170.467 1584.92C170.467 1686.46 94.5459 1768.77 1 1768.77",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 1393.77C86.4115 1393.77 155.825 1476.08 155.825 1577.61C155.825 1679.14 86.4115 1761.73 1 1761.73",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 1386.46C78.2771 1386.46 140.912 1468.77 140.912 1570.3C140.912 1671.83 78.277 1754.14 1 1754.14",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 1378.87C70.1427 1378.87 126.27 1461.18 126.27 1562.72C126.27 1664.25 70.1426 1746.83 1 1746.83",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 1371.56C62.0082 1371.56 111.628 1453.87 111.628 1555.41C111.628 1656.94 62.0082 1739.52 1 1739.52",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 1364.25C53.8738 1364.25 96.7151 1446.56 96.7151 1548.1C96.7151 1649.63 53.8738 1732.21 1 1732.21",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 1356.94C45.7394 1356.94 82.0731 1439.25 82.0731 1540.79C82.0731 1642.32 45.7393 1724.9 1 1724.9",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 1349.63C37.6049 1349.63 67.4312 1431.94 67.4312 1533.48C67.4311 1635.01 37.6049 1717.32 1 1717.32",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 1342.32C29.4705 1342.32 52.5181 1424.63 52.518 1526.17C52.518 1627.7 29.4705 1710.01 1 1710.01",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 1334.74C21.3361 1334.74 37.8761 1417.05 37.8761 1518.59C37.8761 1620.12 21.3361 1702.7 1 1702.7",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 1327.43C13.2017 1327.43 23.2341 1409.74 23.2341 1511.27C23.2341 1612.81 13.2016 1695.39 1 1695.39",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1592.5C102.68 1592.5 185.109 1510.19 185.109 1408.66C185.109 1307.12 102.68 1224.54 1.00003 1224.54",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1599.81C94.5459 1599.81 170.467 1517.5 170.467 1415.97C170.467 1314.43 94.5459 1232.12 1.00003 1232.12",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1607.12C86.4115 1607.12 155.825 1524.81 155.825 1423.28C155.825 1321.74 86.4115 1239.16 1.00003 1239.16",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1614.43C78.277 1614.43 140.912 1532.12 140.912 1430.59C140.912 1329.05 78.2771 1246.47 1.00003 1246.47",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1621.74C70.1426 1621.74 126.27 1539.43 126.27 1437.9C126.27 1336.36 70.1427 1253.78 1.00003 1253.78",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1629.05C62.0082 1629.05 111.628 1546.74 111.628 1445.21C111.628 1343.68 62.0082 1261.36 1.00003 1261.36",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1636.64C53.8738 1636.64 96.7151 1554.33 96.7151 1452.79C96.7151 1351.26 53.8738 1268.68 1.00003 1268.68",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1643.95C45.7393 1643.95 82.0731 1561.64 82.0731 1460.1C82.0731 1358.57 45.7394 1275.99 1.00003 1275.99",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1651.26C37.6049 1651.26 67.4311 1568.95 67.4312 1467.41C67.4312 1365.88 37.6049 1283.57 1.00003 1283.57",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1658.57C29.4705 1658.57 52.518 1576.26 52.518 1474.72C52.5181 1373.19 29.4705 1290.88 1.00003 1290.88",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1665.88C21.3361 1665.88 37.8761 1583.57 37.8761 1482.03C37.8761 1380.5 21.3361 1297.92 1.00003 1297.92",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1673.19C13.2016 1673.19 23.2341 1590.88 23.2341 1489.34C23.2341 1387.81 13.2017 1305.5 1.00003 1305.5",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1680.77C5.06721 1680.77 8.32099 1598.46 8.321 1496.92C8.32101 1395.39 5.06724 1312.81 1.00003 1312.81",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 1320.12C5.06724 1320.12 8.32101 1402.43 8.321 1503.96C8.32099 1574.09 6.6941 1635.01 4.52492 1666.15",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1960.19C102.68 1960.19 185.109 1877.88 185.109 1776.35C185.109 1674.81 102.68 1592.5 1.00003 1592.5",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1967.77C94.5459 1967.77 170.467 1885.19 170.467 1783.66C170.467 1682.12 94.5459 1599.81 1.00003 1599.81",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1975.08C86.4115 1975.08 155.825 1892.77 155.825 1791.24C155.825 1689.7 86.4115 1607.12 1.00003 1607.12",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1982.39C78.277 1982.39 140.912 1900.08 140.912 1798.55C140.912 1697.01 78.2771 1614.43 1.00003 1614.43",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1989.7C70.1426 1989.7 126.27 1907.39 126.27 1805.86C126.27 1704.33 70.1427 1621.74 1.00003 1621.74",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1997.01C62.0082 1997.01 111.628 1914.7 111.628 1813.17C111.628 1711.64 62.0082 1629.05 1.00003 1629.05",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2004.33C53.8738 2004.33 96.7151 1922.01 96.7151 1820.48C96.7151 1718.95 53.8738 1636.64 1.00003 1636.64",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2011.91C45.7393 2011.91 82.0731 1929.6 82.0731 1828.06C82.0731 1726.53 45.7394 1643.95 1.00003 1643.95",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2019.22C37.6049 2019.22 67.4311 1936.91 67.4312 1835.1C67.4312 1733.3 37.6049 1651.26 1.00003 1651.26",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2026.53C29.4705 2026.53 52.518 1944.22 52.518 1842.68C52.5181 1741.15 29.4705 1658.84 1.00003 1658.84",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2033.84C21.3361 2033.84 37.8761 1951.53 37.8761 1849.99C37.8761 1748.46 21.3361 1665.88 1.00003 1665.88",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2041.15C13.2016 2041.15 23.2341 1958.84 23.2341 1857.3C23.2341 1755.77 13.2017 1673.19 1.00003 1673.19",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2048.46C5.06721 2048.46 8.32099 1966.15 8.321 1864.61C8.32101 1763.08 5.06724 1680.77 1.00003 1680.77",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 1688.08C5.06724 1688.08 8.32101 1770.39 8.321 1871.92C8.32099 1942.05 6.6941 2002.97 4.52492 2034.11",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 1136.61C102.68 1136.61 185.109 1054.3 185.109 952.769C185.109 851.235 102.68 768.654 1 768.654",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 1143.92C94.5459 1143.92 170.467 1061.61 170.467 960.08C170.467 858.546 94.5459 776.235 1 776.235",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 1151.23C86.4115 1151.23 155.825 1068.92 155.825 967.39C155.825 865.856 86.4115 783.275 1 783.275",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 1158.55C78.2771 1158.55 140.912 1076.24 140.912 974.701C140.912 873.166 78.277 790.856 1 790.856",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 1166.13C70.1427 1166.13 126.27 1083.82 126.27 982.282C126.27 880.748 70.1426 798.166 1 798.167",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 1173.44C62.0082 1173.44 111.628 1091.13 111.628 989.592C111.628 888.058 62.0082 805.477 1 805.477",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 1180.75C53.8738 1180.75 96.7151 1098.44 96.7151 996.903C96.7151 895.369 53.8738 812.787 1 812.787",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 1188.06C45.7394 1188.06 82.0731 1105.75 82.0731 1004.21C82.0731 902.679 45.7393 820.098 1 820.098",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 1195.37C37.6049 1195.37 67.4312 1113.06 67.4312 1011.52C67.4311 909.989 37.6049 827.679 1 827.679",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 1202.68C29.4705 1202.68 52.5181 1120.37 52.518 1018.83C52.518 917.3 29.4705 834.989 1 834.99",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 1210.26C21.3361 1210.26 37.8761 1127.95 37.8761 1026.42C37.8761 924.881 21.3361 842.3 1 842.3",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 1217.57C13.2017 1217.57 23.2341 1135.26 23.2341 1033.73C23.2341 932.192 13.2016 849.611 1 849.611",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 952.499C102.68 952.499 185.109 1034.81 185.109 1136.34C185.109 1237.88 102.68 1320.46 1.00003 1320.46",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 945.188C94.5459 945.188 170.467 1027.5 170.467 1129.03C170.467 1230.57 94.5459 1312.88 1.00003 1312.88",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 937.877C86.4115 937.877 155.825 1020.19 155.825 1121.72C155.825 1223.26 86.4115 1305.84 1.00003 1305.84",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 930.567C78.277 930.567 140.912 1012.88 140.912 1114.41C140.912 1215.95 78.2771 1298.53 1.00003 1298.53",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 923.257C70.1426 923.257 126.27 1005.57 126.27 1107.1C126.27 1208.64 70.1427 1291.22 1.00003 1291.22",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 915.946C62.0082 915.946 111.628 998.256 111.628 1099.79C111.628 1201.33 62.0082 1283.64 1.00003 1283.64",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 908.365C53.8738 908.365 96.7151 990.675 96.7151 1092.21C96.7151 1193.74 53.8738 1276.33 1.00003 1276.33",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 901.054C45.7393 901.054 82.0731 983.365 82.0731 1084.9C82.0731 1186.43 45.7394 1269.01 1.00003 1269.01",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 893.744C37.6049 893.744 67.4311 976.054 67.4312 1077.59C67.4312 1179.12 37.6049 1261.43 1.00003 1261.43",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 886.433C29.4705 886.433 52.518 968.744 52.518 1070.28C52.5181 1171.81 29.4705 1254.12 1.00003 1254.12",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 879.123C21.3361 879.123 37.8761 961.434 37.8761 1062.97C37.8761 1164.5 21.3361 1247.08 1.00003 1247.08",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 871.812C13.2016 871.812 23.2341 954.123 23.2341 1055.66C23.2341 1157.19 13.2017 1239.5 1.00003 1239.5",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 864.231C5.06721 864.231 8.32099 946.542 8.321 1048.08C8.32101 1149.61 5.06724 1232.19 1.00003 1232.19",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 1224.88C5.06724 1224.88 8.32101 1142.57 8.321 1041.04C8.32099 970.91 6.6941 909.989 4.52492 878.852",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 584.809C102.68 584.809 185.109 667.12 185.109 768.654C185.109 870.188 102.68 952.499 1.00003 952.499",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 577.228C94.5459 577.228 170.467 659.809 170.467 761.343C170.467 862.878 94.5459 945.188 1.00003 945.188",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 569.917C86.4115 569.917 155.825 652.228 155.825 753.762C155.825 855.296 86.4115 937.878 1.00003 937.878",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 562.607C78.277 562.607 140.912 644.917 140.912 746.451C140.912 847.986 78.2771 930.567 1.00003 930.567",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 555.296C70.1426 555.296 126.27 637.607 126.27 739.141C126.27 840.675 70.1427 923.257 1.00003 923.257",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 547.986C62.0082 547.986 111.628 630.296 111.628 731.831C111.628 833.365 62.0082 915.946 1.00003 915.946",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 540.675C53.8738 540.675 96.7151 622.986 96.7151 724.52C96.7151 826.054 53.8738 908.365 1.00003 908.365",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 533.094C45.7393 533.094 82.0731 615.405 82.0731 716.939C82.0731 818.473 45.7394 901.055 1.00003 901.055",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 525.784C37.6049 525.784 67.4311 608.094 67.4312 709.899C67.4312 811.704 37.6049 893.744 1.00003 893.744",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 518.473C29.4705 518.473 52.518 600.784 52.518 702.318C52.5181 803.852 29.4705 886.163 1.00003 886.163",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 511.163C21.3361 511.163 37.8761 593.473 37.8761 695.008C37.8761 796.542 21.3361 879.123 1.00003 879.123",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 503.852C13.2016 503.852 23.2341 586.163 23.2341 687.697C23.2341 789.231 13.2017 871.813 1.00003 871.813",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 496.542C5.06721 496.542 8.32099 578.852 8.321 680.387C8.32101 781.921 5.06724 864.231 1.00003 864.231",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 856.921C5.06724 856.921 8.32101 774.61 8.321 673.076C8.32099 602.95 6.6941 542.029 4.52492 510.892",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 224.386C102.68 224.386 185.109 306.697 185.109 408.231C185.109 509.765 102.68 592.347 1 592.347",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 217.076C94.5459 217.076 170.467 299.386 170.467 400.921C170.467 502.455 94.5459 584.765 1 584.765",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 209.766C86.4115 209.766 155.825 292.076 155.825 393.61C155.825 495.145 86.4115 577.726 1 577.726",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 202.455C78.2771 202.455 140.912 284.765 140.912 386.3C140.912 487.834 78.277 570.145 1 570.145",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 194.874C70.1427 194.874 126.27 277.184 126.27 378.718C126.27 480.253 70.1426 562.834 1 562.834",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 187.563C62.0082 187.563 111.628 269.874 111.628 371.408C111.628 472.942 62.0082 555.524 1 555.524",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 180.253C53.8738 180.253 96.7151 262.563 96.7151 364.098C96.7151 465.632 53.8738 548.213 1 548.213",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 172.942C45.7394 172.942 82.0731 255.253 82.0731 356.787C82.0731 458.321 45.7393 540.903 1 540.903",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 165.632C37.6049 165.632 67.4312 247.942 67.4312 349.477C67.4311 451.011 37.6049 533.322 1 533.322",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 158.321C29.4705 158.321 52.5181 240.632 52.518 342.166C52.518 443.7 29.4705 526.011 1 526.011",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 150.74C21.3361 150.74 37.8761 233.051 37.8761 334.585C37.8761 436.119 21.3361 518.7 1 518.7",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 143.43C13.2017 143.43 23.2341 225.74 23.2341 327.274C23.2341 428.809 13.2016 511.39 1 511.39",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 408.502C102.68 408.502 185.109 326.192 185.109 224.657C185.109 123.123 102.68 40.5416 1.00003 40.5416",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 415.812C94.5459 415.813 170.467 333.502 170.467 231.968C170.467 130.433 94.5459 48.1229 1.00003 48.1229",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 423.123C86.4115 423.123 155.825 340.813 155.825 239.278C155.825 137.744 86.4115 55.1627 1.00003 55.1627",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 430.434C78.277 430.434 140.912 348.123 140.912 246.589C140.912 145.055 78.2771 62.4733 1.00003 62.4733",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 437.744C70.1426 437.744 126.27 355.433 126.27 253.899C126.27 152.365 70.1427 69.7836 1.00003 69.7836",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 445.054C62.0082 445.054 111.628 362.744 111.628 261.21C111.628 159.675 62.0082 77.3649 1.00003 77.3649",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 452.636C53.8738 452.636 96.7151 370.325 96.7151 268.791C96.7151 167.257 53.8738 84.6754 1.00003 84.6754",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 459.946C45.7393 459.946 82.0731 377.636 82.0731 276.101C82.0731 174.567 45.7394 91.9857 1.00003 91.9857",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 467.257C37.6049 467.257 67.4311 384.946 67.4312 283.412C67.4312 181.877 37.6049 99.567 1.00003 99.567",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 474.567C29.4705 474.567 52.518 392.257 52.518 290.722C52.5181 189.188 29.4705 106.878 1.00003 106.878",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 481.877C21.3361 481.877 37.8761 399.567 37.8761 298.033C37.8761 196.498 21.3361 113.917 1.00003 113.917",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 489.188C13.2016 489.188 23.2341 406.878 23.2341 305.343C23.2341 203.809 13.2017 121.498 1.00003 121.498",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 496.769C5.06721 496.769 8.32099 414.459 8.321 312.925C8.32101 211.39 5.06724 128.809 1.00003 128.809",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 136.119C5.06724 136.119 8.32101 218.43 8.321 319.964C8.32099 390.091 6.6941 451.011 4.52492 482.148",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 776.191C102.68 776.191 185.109 693.881 185.109 592.347C185.109 490.812 102.68 408.502 1.00003 408.502",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 783.773C94.5459 783.773 170.467 701.191 170.467 599.657C170.467 498.123 94.5459 415.812 1.00003 415.812",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 791.083C86.4115 791.083 155.825 708.773 155.825 607.238C155.825 505.704 86.4115 423.123 1.00003 423.123",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 798.394C78.277 798.394 140.912 716.083 140.912 614.549C140.912 513.015 78.2771 430.433 1.00003 430.433",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 805.704C70.1426 805.704 126.27 723.394 126.27 621.859C126.27 520.325 70.1427 437.744 1.00003 437.744",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 813.015C62.0082 813.015 111.628 730.704 111.628 629.17C111.628 527.636 62.0082 445.054 1.00003 445.054",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 820.325C53.8738 820.325 96.7151 738.015 96.7151 636.48C96.7151 534.946 53.8738 452.636 1.00003 452.636",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 827.906C45.7393 827.906 82.0731 745.596 82.0731 644.061C82.0731 542.527 45.7394 459.946 1.00003 459.946",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 835.217C37.6049 835.217 67.4311 752.906 67.4312 651.101C67.4312 549.296 37.6049 467.256 1.00003 467.256",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 842.527C29.4705 842.527 52.518 760.217 52.518 658.683C52.5181 557.148 29.4705 474.838 1.00003 474.838",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 849.838C21.3361 849.838 37.8761 767.527 37.8761 665.993C37.8761 564.459 21.3361 481.877 1.00003 481.877",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 857.148C13.2016 857.148 23.2341 774.838 23.2341 673.303C23.2341 571.769 13.2017 489.188 1.00003 489.188",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 864.459C5.06721 864.459 8.32099 782.148 8.321 680.614C8.32101 579.08 5.06724 496.769 1.00003 496.769",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 504.08C5.06724 504.08 8.32101 586.39 8.321 687.925C8.32099 758.051 6.6941 818.971 4.52492 850.109",
    stroke: "#322B92",
    strokeMiterlimit: 10
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioBgLeft);
export default __webpack_public_path__ + "static/media/portfolio-bg-left.77675d9a9844ae99764f1fe3ed7e105e.svg";
export { ForwardRef as ReactComponent };